var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 32.4685V36.0409C22.5 37.0917 23.3526 37.9382 24.3973 37.9382H25.1838V30.5652H24.3973C23.3466 30.5652 22.5 31.4178 22.5 32.4625V32.4685Z",
    fill: "#269C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0933 30.571H55.3008V37.9441H56.0933C57.144 37.9441 57.9906 37.0915 57.9906 36.0468V32.4743C57.9906 31.4236 57.138 30.577 56.0933 30.577V30.571Z",
    fill: "#269C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9139 24.5551C49.7764 23.8046 46.1139 23 40.2419 23C34.3699 23 30.7014 23.8346 28.5399 24.5971C27.0088 25.1375 25.9941 26.5965 25.9941 28.2176V48.6255C25.9941 50.3968 27.189 51.8858 28.8221 52.3361V54.2034C28.8221 55.6203 29.9809 56.7791 31.3978 56.7791H32.3945C33.8115 56.7791 34.9703 55.6203 34.9703 54.2034V52.4742H45.5255V54.2034C45.5255 55.6203 46.6843 56.7791 48.1013 56.7791H49.098C50.5149 56.7791 51.6737 55.6203 51.6737 54.2034V52.3361C53.3008 51.8858 54.5017 50.3968 54.5017 48.6255V28.1876C54.5017 26.5484 53.469 25.0954 51.9259 24.5551H51.9139ZM36.6634 25.6058H43.8264C44.5108 25.6058 45.0692 26.1642 45.0692 26.8486C45.0692 27.5331 44.5108 28.0915 43.8264 28.0915H36.6634C35.979 28.0915 35.4206 27.5331 35.4206 26.8486C35.4206 26.1642 35.979 25.6058 36.6634 25.6058ZM31.0376 50.5529C30.0169 50.5529 29.1823 49.7243 29.1823 48.6976C29.1823 47.6709 30.0109 46.8423 31.0376 46.8423C32.0643 46.8423 32.8929 47.6709 32.8929 48.6976C32.8929 49.7243 32.0643 50.5529 31.0376 50.5529ZM49.4462 50.5529C48.4255 50.5529 47.5909 49.7243 47.5909 48.6976C47.5909 47.6709 48.4195 46.8423 49.4462 46.8423C50.4729 46.8423 51.3015 47.6709 51.3015 48.6976C51.3015 49.7243 50.4729 50.5529 49.4462 50.5529ZM52.118 42.1171C52.118 43.3299 51.1334 44.3146 49.9205 44.3146H30.5633C29.3504 44.3146 28.3658 43.3299 28.3658 42.1171V32.5525C28.3658 31.3397 29.3504 30.355 30.5633 30.355H49.9205C51.1334 30.355 52.118 31.3397 52.118 32.5525V42.1171Z",
    fill: "#269C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusTicketIcon);
export default __webpack_public_path__ + "static/media/bus-ticket-icon.bde8de0b35ec835cb38aff37d031e35d.svg";
export { ForwardRef as ReactComponent };